import axios from 'axios';

// filterValues = { invoice_id: '', status: '' }
const getAllUserInstallmentsApi = async (token, filterValues, type) => {
  let url = '';
  if (type === 'user') {
    url = `/User/getInstallments?id=${
      filterValues?.userId || filterValues?.supplierId || ''
    }&page=${filterValues?.page || '1'}`;
  } else if (type === 'supplier') {
    url = `/Supplier/getInstallments?id=${
      filterValues?.supplierId || ''
    }&page=${filterValues?.page || '1'}`;
  }
  try {
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAllUserInstallmentsApi;
